import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/style/index.scss' // global css
import '@/style/normalize.css' // global css
import locale from 'element-ui/lib/locale/lang/en'
import moment from 'moment';



Vue.use(ElementUI, { locale })

Vue.prototype.$moment = moment;
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
